import { TableComboInput, TableEdit, TableSelect} from "../components/AgComponents"
import { useSnapshot } from "valtio"
import { Fragment, useEffect, useRef, useState } from "react"
import {
    quoteDataRec, chargesStore1, cargoStore, configStore, entityStore, EntityV2Store,
    loginStore
} from '../state/CommonState'
import Utils from "../util/Utils"
import { chargesValidationStore } from "../state/validation-stores"
import chargedetails from "../assets/images/chargedetails.svg";
import { Card } from "../v3-componets/AgCard"
import { Headspan } from "../v3-componets/AgHeadspan"
import AiChargeParse, { fillChargesStore, addAiChargeHistory, AiChargeHistory } from "../components/AiChargeParse"
import { TableLabel } from "../v3-componets/AgTableLabel"
import { groupedByCategory, PRICING_CATEGORY } from "../charges_data/LCLCharges"
import TenantUtils from "../util/tenant.utils"
import RoleUtils from "../util/RoleUtils"
import { PERMISSIONS_NEW } from "../util/constants"
import { QuoteCharges1 } from "../state/Types"
console.log("chargesStore1--------->", chargesStore1)


export default function LCLChargesCompv3() {
    const [grandTotal, setGrandTotal] = useState(0.0)
    const [grandTotal1, setGrandTotal1] = useState(0.0)
    const [shipTotal, setShipTotal] = useState(0.0)
    const [conTotal, setConTotal] = useState(0.0)
    const onaccount = ['On Your Account', `Consignee's Account`, `Shipper's Account`]
    const [volumeDiscount, setVolumeDiscount] = useState(0)
    const [showtotal, setShowtotal] = useState(false)
    const [showtotal1, setShowtotal1] = useState(false)
   const isEditingRef = useRef(false);

    useSnapshot(cargoStore)
    useSnapshot(quoteDataRec)
    useSnapshot(entityStore)
    console.log('ChargesComp rendering')
    let [space, setSpace] = useState('')

    let imChargesStore = useSnapshot(chargesStore1)
  
    useEffect(() => {
        let list = chargesStore1.list
        for (let i = 0; i < list.length; i++) {
            if (!list[i].onaccount || !list[i].onaccount.length) list[i].onaccount = 'On Your Account'
        }
        if (!grandTotal) {
            calculateFinalTotal()
            let vd = chargesStore1.list.find(e => e.chargeDescription == 'Volume Discount')
            if (vd) {
                let of = chargesStore1.list.filter(e => e.chargeDescription == 'Ocean Freight')
                if (of && of.length) {
                    if (vd.total > 0) vd.total *= -1
                    let voldis = vd.total 
                    let e = of[0]
                    if (e.perCBM > 0 ||
                        e.perTon > 0 ||
                        e.minimum > 0 ||
                        e.maximum > 0 ||
                        e.perShipment > 0) {
                            e.perShipment = (e.total>0?e.total:e.total*-1) + voldis
                            if (e.perShipment > 0) e.perShipment *= -1
                            console.log('\n\n\nSetting pershipment of OF to', e.perShipment, '\n-----------\n')
                        }
                }
            }
        }
    }, [imChargesStore])
    useEffect(() => {
        let entity = EntityV2Store.list.find((e) => e.entityId === quoteDataRec.entityId)
        if (entity) {
            let sscope = quoteDataRec.shipmentScope
            sscope = sscope.toLowerCase()
            let country = '' + entity.entityCountry
            country = country.toLowerCase()
            let cecisorigin = false
            let cecisdestination = false
            let por = ('' + quoteDataRec.portOfLoading).toLowerCase()
            let pod = ('' + quoteDataRec.finalPlaceOfDelivery).toLowerCase()
            let q = quoteDataRec
            if(entity._id == "TBA" && q.isfromAgragaEnquiry != undefined && q.isfromAgragaEnquiry=='Yes' && q.countryFromEnquiry != undefined){
                country = q.countryFromEnquiry.toLowerCase()
            }
            if(country.includes('hong kong')){
                cecisorigin = por.includes('hong kong')
                cecisdestination = pod.includes('hong kong')
            }else {
                cecisorigin = por.includes(country)
                cecisdestination = pod.includes(country)
            }

            chargesStore1.list.map((e) => {
                if(sscope.length!=0 && country.length!=0 && por.length!=0 && pod.length!=0){
                    if(e.onaccount!=undefined){
                        if(onaccount.indexOf(e.onaccount)==-1){
                            e.onaccount = "On Your Account"
                        }
                    }
                }
                return e
            })
        }
        console.log('DETECTED CHANGES=', quoteDataRec.entityId, quoteDataRec.portOfReceipt, quoteDataRec.portOfDischarge)
    }, [
        quoteDataRec.entity,quoteDataRec.entityId, quoteDataRec.portOfLoading,
        quoteDataRec.finalPlaceOfDelivery, quoteDataRec.shipmentScope
    ])
  const deleteRec = (id,key='list') => {
  let records = [...chargesStore1[key]];
  const index = records.findIndex(e => e.id === id);
  if (index === -1) return;

  const deletedRecord = records[index];
  const deletedCategory = deletedRecord.category;

  records.splice(index, 1);

  const categoryStillExists = records.some(
    e => e.category === deletedCategory
  );

  if (!categoryStillExists) {
    let obj = new QuoteCharges1();
    obj.category = deletedCategory;
    obj.table = 1;
    records.push({
      ...obj,
      id: records.length + 1
    });
  }

  records.forEach((e, i) => {
    e.id = i + 1;
  });

if(key=='list'){
  if (id <= chargesStore1.initialLength) {
    chargesStore1.initialLength = Math.max(
      0,
      chargesStore1.initialLength - 1
    );
  }
}
  chargesStore1[key] = records;
  autoRecalculate()
};

   const Ts = ({ id, name, dataList, tableNo, ...otherProps }) => {
   const table = getTableData(tableNo)
  const record = table.find(r => r.id === id)
  const index = table.findIndex(r => r.id === id)
  if (!record) return null;

  const callback = ()=>{
    if(tableNo==3){
      record['updateby'] = loginStore.email
      record['updateon'] = Date.now()
    }
  }

  return (
    <TableSelect
    placeHolder="Select Currency"
      record={record}
      name={name}
    calculate={autoRecalculate}
      dataList={dataList}
      callback ={callback}
      isValid={tableNo == 1 ?chargesValidationStore.isValidCharge(name, index): true }
      {...otherProps}
    />
  );
};

  const Te = ({ id, name, tableNo, isEditingRef }) => {
   const table = getTableData(tableNo)
   
  const record = table.find(r => r.id === id)
  const index = table.findIndex(r => r.id === id)
  if (!record) return null;

  if (
    (name === 'chargeDescription' && index < chargesStore1.initialLength && record[name]) ||
    record.chargeDescription === 'Volume Discount'
  ) {
    return <TableLabel record={record} name={name} />;
  }

  return (
    <TableComboInput
    placeHolder="Select Description"
      record={record}
      name={name}
      dataList={configStore.getChargeDescriptionList('lcl')}
      isValid={tableNo == 1 ?chargesValidationStore.isValidCharge(name, index): true }
    />
    // <TableEdit
    //   isblue
    //   isEditingRef={isEditingRef}
    //   record={record}
    //   isreadonly={tableNo !== 1}
    //   name={name}
    //   isValid={tableNo == 1 ?chargesValidationStore.isValidCharge(name, index) : true}
    // />
  );
};

   const Tn = ({ id, name,tableNo, chargeType, ...otherProps }) => {
  const table = getTableData(tableNo)
  const record = table.find(r => r.id === id)
  const index = table.findIndex(r => r.id === id)
   const currencyMissing = !record.currency;

  if (!record) return null;

  if (currencyMissing ||
    (record.disabled && record.disabled.includes(name)) ||
    record.chargeDescription === 'Volume Discount'
  ) {
    return (
      <input className="input is-small"
        disabled
        style={{
          backgroundColor: '#dddddd',
          border: 'none'
        }}
      />
    );
  }

  return (
    <TableEdit
      record={record}
      calculate={autoRecalculate}
      name={name}
      type="number"
      chargeType={chargeType}
      isValid={tableNo == 1 ? chargesValidationStore.isValidCharge(name, index) : true}
      {...otherProps}
    />
  );
};

    const ifNotFCL = () => quoteDataRec.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    const calculateFinalTotal = () => {
        let tot = 0
        let tot1 = 0
        let shiptot = 0
        let contot = 0
        chargesStore1.list.map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            if (e.chargeDescription == 'Volume Discount') {
                if (e.total > 0) e.total *= -1
                setVolumeDiscount(e.total * erate)
            } else if(e.chargeDescription !== 'Rebate' && e.chargeDescription !== 'Freight Commission'){
                if (e.onaccount && e.onaccount.startsWith('Cons')) contot += e.total * erate
                else if (e.onaccount && e.onaccount.startsWith('Ship')) shiptot += e.total * erate
                else {
                    tot += e.total * erate
                }
            }
        })
        chargesStore1.pkb.map((e) => {
            let erate = configStore.getExchangeRateinr(e)
            if (!erate || erate === 0) erate = 1.0
            tot1 += e.total * erate
        })
        if(tot && showtotal==false){
            setShowtotal(true)
        }
        if(tot1 && showtotal1==false){
            setShowtotal1(true)
        }
        setGrandTotal1(tot1)
        setGrandTotal(tot)
        setShipTotal(shiptot)
        setConTotal(contot)
        return finalTotal;
    }
    const getTableData = (tableNo) => {
  switch (tableNo) {
    case 1: return chargesStore1.list
    case 2: return chargesStore1.rebate
    case 3: return chargesStore1.pkb
    default: return []
  }
}


    const autoRecalculate = () => {
    setVolumeDiscount(0);
    cargoStore.calculateCargoTotals();
    imChargesStore.calculateLCLChargesTotals();
    calculateFinalTotal();
    setShowtotal(true);
};

useEffect(() => {
  const handler = (e) => {
    if (isEditingRef?.current) return;
    if (e.target.closest("input, textarea, select")) return;

    autoRecalculate();
  };

  document.addEventListener("mouseup", handler);
  return () => document.removeEventListener("mouseup", handler);
}, []);



const emptyRecordCharges=(tableNo, categoryKey, desc)=>{
  const obj = { ...imChargesStore.newRec };
          obj.category = categoryKey.toUpperCase();
          obj.table = tableNo;
    chargesStore1[categoryKey.toLowerCase()] = [{
          ...obj,
         id: `temp-${categoryKey}-${Date.now()}`,
         chargeDescription: desc,
        }]
}
    
    
 
const chargesByTable = [imChargesStore.list]
const isEmpty = (val) =>
  val == null ||
  (Array.isArray(val) && val.length === 0) ||
  (typeof val === "object" && Object.keys(val).length === 0);

if (isEmpty(imChargesStore.rebate)) {
  emptyRecordCharges(2, 'rebate', 'Rebate');
}

if (isEmpty(imChargesStore.pkb)) {
  emptyRecordCharges(3, 'pkb', 'Freight Commission');
}

 chargesByTable.push(imChargesStore.rebate)
 chargesByTable.push(imChargesStore.pkb);


    return (
      <>
  <hr />

  {Object.entries(chargesByTable).map(([tableNo, tableCharges]) => {
    tableNo = Number(tableNo) + 1;
    const groupedCharges = groupedByCategory(tableCharges);

    if((tableNo === 2 && !RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.REBATE) ) || (tableNo ===3 && !RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATION.PKB))) {
      return null;
    }

    return (
      <Card key={tableNo} style={{ marginBottom: "24px" }}>
        {tableNo == 1 && <div><span><img style={{paddingTop: '10px'}} src={chargedetails} /></span>
        <Headspan
          color="#000"
          fontSize="14px"
          fontWeight="900"
          data={`  Charge Details`}
        /><AiChargeParse shipmentType="LCL" onCharges={(l, entry) => { addAiChargeHistory(quoteDataRec, entry, "list"); return fillChargesStore(chargesStore1, "list", l, autoRecalculate) }} /></div>}
        {tableNo == 1 && <AiChargeHistory history={quoteDataRec.aiChargeHistory} chargeKey="list" />}

        <div className="table-container">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              {ifNotFCL() && (
                <tr>
                  <th></th><th></th><th></th><th></th>
                  {tableNo == 1 && <th colSpan="4"
                      style={{
                        background: "#4BA7DD",
                        color: "#fff",
                        fontWeight: 900,
                        padding: "10px",
                        textAlign: "center"
                      }}>
                    Per Unit
                  </th>}
                  <th></th><th></th><th></th>
                </tr>
              )}

              <tr style={{ fontWeight: 900, border: "1px solid #D4D4D4" }}>
                <th  style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>#</th>
                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Charge Description</th>
                {tableNo == 1 && <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>On Account</th>}
                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Currency</th>
                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Per CBM</th>
                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Per Ton</th>
                {tableNo === 1 ?<th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Minimum</th>: <></>}
                 {tableNo === 1 ?<th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Maximum</th>:<></>}
                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Per Shipment</th>
                {tableNo==3 && <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Update By</th>}
                {tableNo==3 && <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Update On</th>}
                <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: "right" }}>Total</th>
                {(tableNo == 1 || tableNo==3)&& <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Action</th>}
              </tr>
            </thead>

            <tbody>
              {Object.entries(groupedCharges).map(([categoryKey, charges]) => (
                <Fragment key={categoryKey}>
                  <tr>
                    <td colSpan={11}
                        style={{
                          background: "#EAF4FB",
                          fontWeight: 900,
                          padding: "10px",
                          color: "#1E4E79",
                          border: "1px solid #4BA7DD"
                        }}>
                      {PRICING_CATEGORY[categoryKey]?.label}
                    </td>
                  </tr>

                  {charges.map((e, i) => (
                    <tr key={e.id}
                        style={{
                          background: i % 2 ? "#F3F3F3" : "transparent",
                          border: "1px solid #D4D4D4"
                        }}>
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>{i+1}</td>
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Te id={e.id} isEditingRef={isEditingRef} name="chargeDescription" tableNo={tableNo} /></td>
                     {tableNo == 1 &&  <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Ts id={e.id} name="onaccount" dataList={onaccount}  tableNo={tableNo}  /></td>}
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Ts id={e.id} name="currency" dataList={configStore.getCurrencyList()} tableNo={tableNo} /></td>
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Tn id={e.id} name="perCBM"  tableNo={tableNo} chargeType ={e.chargeDescription} /></td>
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Tn id={e.id} name="perTon"  tableNo={tableNo} chargeType ={e.chargeDescription}/></td>
                       {tableNo === 1 ?<td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Tn id={e.id} name="minimum" tableNo={tableNo}  /></td>:<></>}
                      {tableNo === 1 ? <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Tn id={e.id} name="maximum" tableNo={tableNo}  /></td>:<></>}
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}><Tn id={e.id} name="perShipment"  chargeType ={e.chargeDescription}  tableNo={tableNo} /></td>
                      {tableNo==3 && <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>{(e.updateby!=undefined)?<>{e.updateby}</>:""}</td>}
                      {tableNo==3 && <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>{(e.updateon!=undefined)?<>{Utils.formatToDateTime(Number(e.updateon))}</>:""}</td>}
                      <td style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px",textAlign: "right" }}>
                        {e.total && e.currency ? Utils.N(e.total, e.currency) : ""}
                      </td>
                      {(tableNo == 1 || tableNo==3) && <td style={{ textAlign: "center" }}>
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      gap: "8px"
    }}
  >
    <button
      className="button is-danger is-inverted"
      onClick={() => {
        if(tableNo==3){
          deleteRec(e.id,'pkb')
        }else{
          deleteRec(e.id)
        }
      }}
    >
      <i className="fas fa-trash" />
    </button>

    {i === charges.length - 1 ? (
      <button
        className="button is-success is-inverted"
        onClick={() => {
          const obj = new QuoteCharges1()
          obj.category = categoryKey;
          obj.table = tableNo;
          if(tableNo!=3){
            chargesStore1.list.push({
            ...obj,
            id: chargesStore1.list.length + 1
          });
          }else{
            obj.chargeDescription ='Freight Commission'
            chargesStore1.pkb.push({
            ...obj,
            id: charges.length + 1
          });
          }
          
          
          setSpace(space === "" ? " " : "");
        }}
      >
        <i className="fas fa-plus" />
      </button>
    ) : (
      <button
        className="button is-success is-inverted"
        style={{ visibility: "hidden" }}
      >
        <i className="fas fa-plus" />
      </button>
    )}
  </div>
</td>}

                    </tr>
                  ))}
                </Fragment>
              ))}
            </tbody>

                        {!showtotal?<tr style={{border:"solid 0.5px #D4D4D4"}}><td colSpan={11} style={{ textAlign: 'right' }}>
                            </td></tr>:""}
                          {
                            showtotal1 && tableNo ==3 && <tr style={{border:"solid 0.5px #D4D4D4"}}>
                            <td colSpan={8}></td>
                            <td colSpan={2} style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(grandTotal1)}</strong></td>
                        </tr>}
                        {
                            showtotal && tableNo ==1 ?<>
                            <tr style={{border:"solid 0.5px #D4D4D4"}}>
                            <td colSpan={8}></td>
                            <td colSpan={2} style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(grandTotal)}</strong></td>
                            <td style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}} rowSpan={(conTotal && shipTotal && volumeDiscount)?6:(volumeDiscount && (conTotal || shipTotal))?5:(volumeDiscount && !conTotal && !shipTotal)?4:(conTotal && shipTotal)?4:(conTotal || shipTotal)?3:2}>
                       
                            </td>
                        </tr>
                        {
                            volumeDiscount != 0 &&
                            <>
                                <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                    <td colSpan={8} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>Volume Discount :</td>
                                    <td colSpan={2} style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(volumeDiscount)}</strong></td>
                                </tr>
                                <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                    <td colSpan={8} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>TOTAL :</td>
                                    <td colSpan={2} style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(grandTotal + volumeDiscount)}</strong></td>
                                </tr>
                            </>
                        }
                        {
                            shipTotal > 0 &&
                            <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td colSpan={9} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>Total of On Shipper's Account : </td>
                                <td style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(shipTotal)}</strong></td>
                            </tr>
                        }
                        {
                            conTotal > 0 &&
                            <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td colSpan={9} style={{ textAlign: 'right',color:"#555555", padding:"10px", fontWeight:"900"}}>Total of On Consignee's Account : </td>
                                <td style={{ color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px", textAlign: 'right', fontSize: '1.1rem', fontWeight:"900"}}><strong>{Utils.N(conTotal)}</strong></td>
                            </tr>
                        }
                            </>: tableNo !== 1 && <td colSpan={11} style={{ textAlign: 'right' }}><button className="button is-info is-inverted"
                                                        
                                                        onClick={() => {
                                                            setVolumeDiscount(0)
                                    cargoStore.calculateCargoTotals()
                                    let voldis = imChargesStore.calculateLCLChargesTotals()
                                    calculateFinalTotal()
                                    setSpace(space === '' ? ' ' : '')
                                                        }}>
                                            
                                                    </button></td>
                       
                        }
          
                                       


          </table>
        </div>
      </Card>
    );
  })}
</>

    )
}
